module.exports = __webpack_public_path__ + "files/sharepoint-2007-configuration.a95dd5ed.pdf";